<!-- 图片上传组件 -->
<template lang="html">
	<div class="datadata">
		<el-upload class="avatar-uploader" :action="image_up+'admin_base_api/image_up'" :data="{sub_url:sub_url}" :show-file-list="false" :before-upload="before_upload" :on-success="imageSuccess">
			<img v-if="value" :src="api_imgurl(value)" class="avatar">
			<i v-else class="el-icon-plus avatar-uploader-icon"></i>
		</el-upload>
	</div>
</template>
<script>
export default {
	name: 'upload',
	data() {
		return {
			image_up:process.env.API_ROOT,
			loading:null,
		}
	},
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {
		value: {
			type: String,
			default: ''
		},
		sub_url: {
			type: String,
			default: ''
		}
	},
	watch: {
	},
	mounted() {

	},
	methods: {
		before_upload(){
			this.loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
		},
		imageSuccess(res,file){
			if (res.status==200) {
				this.$message.success('图片上传成功');
	            this.$emit('callback', res.data.image);
			}else{
				this.$message.error(res.message);
			}
			this.loading.close();
		},
	}
}
</script>
<style lang="css">
.datadata .avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	display: block;
	width: 100px;
	height: 100px;
	line-height: 100px!important;
	font-size: 28px;
	color: #8c939d;
	text-align: center;
}
.datadata .avatar-uploader .el-upload:hover {
	border-color: #409EFF;
}
.datadata .avatar-uploader .el-upload .avatar{
	width: 100%;
	height: 100%;
	object-fit: contain;
}
.datadata .avatar-uploader .avatar-uploader-icon {
	width: 100%;
	height: 100%;
	line-height: 100px;
	display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/upload.vue